<template>
  <div class="read">
    <div class="head">
      <div class="name">累计阅读</div>
      <div class="read-day">{{recordReport.readDay||0}}<span>天</span></div>
      <div class="statistics">
        <div class="types">
          <span class="name">本数</span>
          <span class="num">{{recordReport.readBookCount||0}}</span>
        </div>
        <div class="types">
          <span class="name">时长(min)</span>
          <span class="num">{{Math.floor(recordReport.readBookTimes/60||0)}}</span>
        </div>
        <div class="types">
          <span class="name">次数</span>
          <span class="num">{{recordReport.readCount||0}}</span>
        </div>
      </div>
    </div>
    <div class="echart-wrapper">
      <ul class="echart-content">
        <li class="echart-rectangle" v-for="item in recordReport.readDetail" :key="item.index">
          <div class="read-number">
            <div class="num">{{item.count || 0}}次</div>
            <div class="rectangular" :style="item.count|calculateHeight"></div>
          </div>
          <div class="read-time">{{item.date|formatDate}}</div>
        </li>
      </ul>
    </div>
    <div class="favorite-books">
      <div class="title">宝宝最喜欢的书</div>
      <div class="content" @click="goDetail(favorBook.book.id)" v-if="favorBook.book">
        <img :src="favorBook.book&&favorBook.book.cover" alt="" class="content-img">
        <div class="content-detail">
          <p class="name">{{favorBook.book&&favorBook.book.name}}</p>
          <p class="count">拥有<span>{{favorBook.readDays||0}}</span>天，共读了<span>{{favorBook.bookRecordVo&&favorBook.bookRecordVo.count||0}}</span>次</p>
          <p class="abstract">{{favorBook.book&&favorBook.book.description}}</p>
        </div>
      </div>
      <img v-else class="empty-records" src="/images/report/empty-books.png" alt="">
    </div>
    <div class="reading-record">
      <div v-if="isNative" class="title" @click="goMore">阅读记录</div>
      <a v-else class="title" :href="downloadPath">阅读记录</a>
      <template v-if="recordList.length">
        <div v-for="(item, index) in recordList" :key="index">
          <div v-if="index<1">
            <div class="statistical">
              <span>{{item.date}}</span>
              <span>共阅读了{{item.books.length||0}}本书</span>
            </div>
            <ul class="swiper">
              <li class="slide-item" v-for="book in item.books" :key="book.id" @click="goDetail(book.id)">
                <img class="books-img" :src="book.cover" alt="">
                <p class="books-name">{{book.name}}</p>
              </li>
            </ul>
          </div>
        </div>
      </template>
      <img v-else class="empty-records" src="/images/report/empty-records.png" alt="">
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { differMomentDay } from "@/utils/filter.js";
import { ExternalInterfaceUtil } from "@/utils";

export default {
  data() {
    return {
      recordReport: {},
      favorBook: {},
      recordList: []
    };
  },
  async mounted() {
    await this.getReadReport();
    this.getRecordList();
    this.getFavorBook();
  },
  computed: {
    ...mapGetters({
      isNative: "externalInterface/isNative",
      mobileType: "externalInterface/mobileType"
    }),
    downloadPath() {
      return this.mobileType === ExternalInterfaceUtil.TYPE.IPHONE
        ? process.env.VUE_APP_IPHONE_DOWNLOAD_URL
        : process.env.VUE_APP_ANDROID_DOWNLOAD_URL;
    },
     appId(){
      return 10003
    }
  },
  methods: {
    getReadReport() {
      return this.$api
        .api_v3_book_record_report_get({
          headers: { appId: this.appId }
        })
        .then(res => {
          if (!res) return;
          this.recordReport = res;
          let { readDetail } = res;
          readDetail.sort((a, b) => {
            return a.date - b.date;
          });
          this.recordReport.readDetail = readDetail;
        });
    },
    getFavorBook() {
      return this.$api
        .api_v3_book_record_favor_get({
          headers: { appId: this.appId }
        })
        .then(res => {
          if (!res) return;
          if (Object.keys(res).length && res.book) {
            this.favorBook = res;
            this.favorBook.readDays = differMomentDay(
              moment(),
              moment(+this.favorBook.bookRecordVo.createDate)
            );
          }
        });
    },
    getRecordList() {
      return this.$api
        .api_v3_book_record_list_post({
          headers: { appId: this.appId },
          data: {
            params: {
              pageNo: 1,
              pageSize: 6
            }
          }
        })
        .then(res => {
          if (!res) return;
          if (Object.keys(res).length && res.records) {
            this.recordList = res.records;
          }
        });
    },
    goDetail(id) {
      if (this.isNative) {
        this.$store.dispatch("externalInterface/navigateTo", {
          name: "books",
          params: {
            id
          }
        });
      } else {
        this.$createToast({
          txt: "请前往APP查看详情哦~",
          type: "txt",
          time: 1500
        }).show();
      }
    },
    goMore() {
      if (this.isNative) {
        this.$store.dispatch("externalInterface/navigateTo", {
          name: "readRecords"
        });
      }
    }
  },
  filters: {
    calculateHeight(num) {
      let height = 0;
      if (num > 0 && num <= 40) {
        height = num * 4;
      } else if (num > 40) {
        height = 4 * 40;
      }
      return {
        height: `${height}px`
      };
    },
    formatDate(date) {
      let arr = "";
      let differDay = differMomentDay(moment(), moment(+date));
      if (differDay === 0) {
        arr = "今天";
      } else if (differDay === 1) {
        arr = "昨天";
      } else {
        let month = moment(+date).month() + 1;
        let day = moment(+date).date();
        arr = `${month}.${day}`;
      }
      return arr;
    }
  }
};
</script>

<style scoped>
.head {
  background: #74b3fa;
  color: #fff;
  text-align: center;
  padding-top: 22px;
  padding-bottom: 67px;
  position: relative;
}
.head .name {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
}
.head .read-day {
  font-size: 56px;
  height: 78px;
  line-height: 78px;
  font-weight: 600;
}
.head .read-day > span {
  font-size: 20px;
  margin-left: 5px;
}
.statistics {
  padding: 6px 32px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.statistics .types {
  display: flex;
  flex-direction: column;
}
.statistics .types .name {
  height: 17px;
  line-height: 17px;
  font-size: 12px;
  margin-bottom: 4px;
}
.statistics .types .num {
  height: 28px;
  line-height: 28px;
  font-size: 20px;
  font-weight: 500;
}
.echart-wrapper {
  position: relative;
  height: 222px;
}
.echart-wrapper .echart-content {
  width: 313px;
  height: 229px;
  box-shadow: 0px 0px 14px 2px rgba(116, 179, 250, 0.2);
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: -40px;
  /* border-radius: 12px; */
  background: url("/images/report/grid-bg.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.echart-content .echart-rectangle {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.echart-rectangle .read-number {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
}
.echart-rectangle .read-number .num {
  height: 17px;
  font-size: 12px;
  font-weight: bold;
  color: rgba(36, 67, 82, 1);
  line-height: 17px;
  margin-bottom: 4px;
}
.echart-rectangle .read-number .rectangular {
  /* height:160px; */
  width: 20px;
  background: #74b3fa;
}
.echart-rectangle .read-time {
  flex: 0 0 30px;
  height: 30px;
  padding-top: 8px;
  font-size: 12px;
  font-weight: 500;
  color: #d1dade;
}
.title {
  display: block;
  height: 64px;
  line-height: 64px;
  color:rgba(36,67,82,1);
  font-weight: 500;
  font-size:18px;
  padding-left: 10px;
  position: relative;
  margin-bottom: 14px;
}
/* .title::before {
  content: "";
  width: 51px;
  height: 51px;
  position: absolute;
  left: -37px;
  top: 5px;
  border-radius: 50%;
} */
.empty-records{
  width: 104px;
  height: 103px;
  display: block;
  margin: 14px auto;
}
/* .favorite-books .title::before {
  background: rgba(0, 181, 226, 1);
} */
.content {
  padding: 0 32px;
  display: flex;
  justify-content: space-between;
}
.content-img {
  width: 94px;
  height: 94px;
  border-radius: 12px;
}
.content .content-detail {
  width: 202px;
}
.content-detail .name {
  height: 22px;
  font-size: 16px;
  font-weight: 500;
  color: #244352;
  line-height: 22px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.content-detail .count {
  height: 28px;
  line-height: 28px;
  font-size: 14px;
  color: #6a92a4;
  margin: 2px 0 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.content-detail .count > span {
  font-size: 20px;
  color: #ffc44c;
}
.content-detail .abstract {
  height: 34px;
  line-height: 17px;
  font-size: 12px;
  color: #6a92a4;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.reading-record {
  margin-top: 30px;
}
/* .reading-record .title::before {
  background: #ffc44c;
} */
.reading-record .title::after {
  content: "";
  width: 9px;
  height: 12px;
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  background: url("/images/report/arrow_read.png") no-repeat;
  background-size: 100% 100%;
}
.reading-record .statistical {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  color: #6a92a4;
  padding: 0 32px;
  display: flex;
  justify-content: space-between;
}
.swiper {
  padding: 14px 0 14px 32px;
  white-space: nowrap;
  overflow-x: scroll;
}
.swiper::-webkit-scrollbar {
  display: none;
}
.slide-item {
  display: inline-block;
  margin-right: 15px;
}
/* .slide-item:nth-last-of-type(1){
  margin-right: 0;
} */
.slide-item .books-img {
  width: 94px;
  height: 94px;
  border-radius: 12px;
}
.slide-item .books-name {
  width: 94px;
  height: 20px;
  font-size: 14px;
  color: rgba(36, 67, 82, 1);
  line-height: 20px;
  margin-top: 8px;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
